<template>
  <swiper
    :options="swiperOptions"
    ref="mySwiper">
    <swiper-slide v-for="i in 5" :key="i">
      Slide {{ i }}
    </swiper-slide>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'DetailSwiper',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const swiper = this.$refs.mySwiper.swiper
      if (swiper) {
        swiper.slideTo(2)
      }
    })
  }
}
</script>
